import React, { Component } from "react";

import AS from "../../Login/Service/Authentication";
import CS from "../../../commons/services/Common";
import VS from "../../../commons/services/Validation";

import Date from "../../../commons/components/Date";
import DateCustom from "../../../commons/components/DateCustom";
import FileUpload from "../../../commons/components/FileUpload";
import PageTitle from "../../../commons/components/PageTitle";

import {
  CreateForm,
  FormSplit,
  FormRow,
  FormThead,
  DefaultVal,
  OptionInfoCreate,
  ButtonArea,
  BtnGroup,
  Checkbox,
} from "../PlantListStyle";
import InputErrorMsgWrapper from "../../../commons/components/input/InputErrorWrap";
import { Message, MessageBox } from "element-react";
import { CONFIRM_TEXT } from "../../../commons/constants/confirm/CONFIRM_TEXT";
import { ROUTES } from "../../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";
import { LabelWidthClass, OptionInfoCreateGrid } from "./translationUiConts";
import SelectBox from "../../../commons/components/select/SelectBox";

class SolarPanelCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plantId: "",
      operationStartDt: "",
      serviceWarrantyDt: "",
      isSaved: true,
      isRequired: false,
      validationErrors: {},
      selectedPlantTypeId: 1,
      // isFocus: React.createRef(),
    };

    this.moveNextStep = this.moveNextStep.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePlantList = this.handlePlantList.bind(this);
    this.removeError = this.removeError.bind(this);
    this.fileInfos = {};
  }

  componentDidMount() {
    const { state } = this.props.location; // 전달된 state에서 projectId 추출
    if (state && state.projectId) {
      this.setState({ projectId: state.projectId });
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    const isSaved = await this.savePlant();

    if (isSaved) {
      this.setState({ isSaved: true });
    }
  }

  async handlePlantList(e) {
    e.preventDefault();
    const { t } = this.props;
    if (this.state.isSaved) {
      this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).MAIN);
      return;
    }

    MessageBox.confirm(CONFIRM_TEXT.MOVE_TO_LIST, "Confirm", {
      type: "info",
      confirmButtonText: this.props.t("key499"),
      cancelButtonText: this.props.t("key498"),
    }).then(() => {
      this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).MAIN);
    }).catch(() => {
      Message({
        iconClass: "cancel",
        type: "info",
        message: t('key573'), // 취소되었습니다.
      })
    });

    // const form = document.querySelector("form");
    // if (form.checkValidity()) {
    //   const isSaved = await this.savePlant();
    //   if (isSaved) {
    //     this.setState({ isSaved: true });
    //     // 저장 후 페이지 이동
    //     this.props.history.push("/plant-list/main/" + this.state.projectId);
    //   }
    // } else {
    //   form.reportValidity();
    // }
  }

  // validation error input으로 스크롤 이동
  scrollErrorInput() {
    const { validationErrors } = this.state;
    const keys = Object.keys(validationErrors);
    // validationErrors에 error가 등록 됐을 때
    if (keys.length > 0) {
      const errorMsgElem = document.querySelector(`.valid-error`); // InputErrorMsgWrapper의 최상단의 span class를 찾음
      errorMsgElem.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  // 해당 input의 validation error 삭제
  removeError(name) {
    const { validationErrors } = this.state;
    delete validationErrors[name];

    this.setState((prev) => ({ ...prev, validationErrors, isSaved: false }));
  }

  // form의 필수 값이 미입력이면 에러메시지 출력
  validateForm(data) {
    const { t } = this.props;
    const validationErrors = {};
    if (!this.state.selectedPlantTypeId) {
      validationErrors.plantType = "발전소 타입을 선택해주세요."; // 발전소 타입을 선택해주세요.
    }
    if (data.get("name") === "") {
      validationErrors.name = t("key574"); // 발전소명을 입력해주세요.
    }
    if (data.get("installationCapacity") === "") {
      validationErrors.installationCapacity = t("key575"); // 설비용량을 입력해주세요.
    }
    if (data.get("installationCnt") === "") {
      validationErrors.installationCnt = t("key576"); // 설치장수를 입력해주세요.
    }
    if (data.get("unitPrice") === "") {
      validationErrors.unitPrice = t("key577"); // SMP + REC 가격을 입력해주세요.
    }
    if (this.state.operationStartDt === "") {
      validationErrors.operationStartDt = t("key578"); // 운전개시일을 입력해주세요.
    }
    if (this.state.serviceWarrantyDt === "") {
      validationErrors.serviceWarrantyDt = t("key579"); // 서비스보증 기간을 입력해주세요.
    }
    if (this.state.selectedPlantTypeId === 2 && !data.get("externalUrl")) {
      validationErrors.externalUrl = "연계 URL을 입력해주세요."; // 연계 URL을 입력해주세요.
    }
    // if (this.fileInfos.floorPlanFile === undefined) {
    //   validationErrors.floorPlanFile = "도면 배치도를 첨부해주세요.";
    // }
    // if (this.fileInfos.oneLineDiagramFile === undefined) {
    //   validationErrors.oneLineDiagramFile = "단선 연결도를 첨부해주세요.";
    // }
    // if (this.fileInfos.serialNoFile === undefined) {
    //   validationErrors.serialNoFile = t("key580"); // 모듈 인버터 시리얼 넘버를 첨부해주세요.
    // }

    this.setState(
      (prev) => ({ ...prev, validationErrors }),
      this.scrollErrorInput // callBack: valid setting 후 error input으로 스크롤 이동
    );

    return Object.keys(validationErrors).length === 0; // validationErrors가 비어있으면 true 반환
  }

  //발전소 등록
  async savePlant() {
    const data = new FormData(document.querySelector("form"));
    if (!this.validateForm(data)) return;
    // if (this.state.operationStartDt === "") {
    //   CS.notification("warning", "운전개시일은 필수 입력값 입니다.");
    //   return;
    // }
    // if (this.state.serviceWarrantyDt === "") {
    //   CS.notification("warning", "서비스보증 기간은 필수 입력값 입니다.");
    //   return;
    // }
    // if (data.get("name") === "") {
    //   this.setState({ isRequired: true });
    //   // this.state.isFocus.current.scrollIntoView({
    //   //   behavior: "smooth",
    //   //   block: "start",
    //   // });
    //   return;
    // }

    this.item = {
      constructorId: AS.getLoggedInId(),
      name: data.get("name"),
      installationCnt: data.get("installationCnt"),
      installationCapacity: data.get("installationCapacity"),
      operationStartDt: this.state.operationStartDt, //data.get('operationYear') + "-" + CS.fillZero(2, data.get('operationMonth')) + "-" + CS.fillZero(2, data.get('operationDay')),
      serviceWarrantyDt: this.state.serviceWarrantyDt, //data.get('warrantyYear') + "-" + CS.fillZero(2, data.get('warrantyMonth')) + "-" + CS.fillZero(2, data.get('warrantyDay')),
      floorPlanFileInfo: this.fileInfos.floorPlanFile,
      oneLineDiagramFileInfo: this.fileInfos.oneLineDiagramFile,
      serialNoFileInfo: this.fileInfos.serialNoFile,
      unitPrice: data.get("unitPrice"),
      optimizerYn: data.get("optimizerYn") === "on" ? "true" : "false",
      projectId: this.state.projectId,
      typeId: this.state.selectedPlantTypeId,
      externalUrl: this.state.selectedPlantTypeId === 2 ? (data.get("externalUrl") || "") : "",
    };

    // console.log("만들 때 쓰는 값", this.item);

    try {
      let result = await CS.create("/cst/api/project-plant", this.item);
      if (result.isSuccess) {
        this.setState({ plantId: result.res.data });
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  doSetFile = (category, fileInfos) => {
    this.fileInfos[category] = fileInfos;
  };

  moveNextStep(plantId) {
    if (plantId === "") {
      CS.notification("warning", "임시저장 후 모듈배치 화면으로 이동하세요.");
      return;
    }
    this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).DRAWING(plantId));
  }
  handleDateChange(name, dt) {
    this.setState({
      [name]: dt,
    });
  }

  render() {
    const { validationErrors, isRequired, isFocus, selectedPlantTypeId } = this.state;
    const { t, i18n } = this.props;
    const { plantTypeMapping } = this.props.location.state || { plantTypeMapping: [] };
    return (
      <>
        <PageTitle title={t("key47")} location={t('key409')} />
        <CreateForm onSubmit={this.handleSubmit}>
          <FormSplit>
            <FormRow>
              <FormThead width={LabelWidthClass(i18n)} required={true}>발전소 타입</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.plantType}
                message={validationErrors.plantType}
              >
                <SelectBox 
                  options={plantTypeMapping}
                  selectedValue={plantTypeMapping.find(type => type.id === this.state.selectedPlantTypeId)?.type || '발전소 타입 선택'}
                  onChange={(id) => {
                    this.setState({ 
                      selectedPlantTypeId: id,
                    });
                    this.removeError('plantType');
                  }}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow className={isRequired ? "required-inp" : ""}>
              <FormThead width={LabelWidthClass(i18n)} required={true}>{t("key411")}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.name}
                message={validationErrors.name}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={t("key412")}
                  onChange={(e) => {
                    this.removeError(e.target.name);
                    VS.characterCheck(e);
                  }}
                  name="name"
                  onFocus={this.removeError}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidthClass(i18n)} required={true}>{t("key413")}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.installationCapacity}
                message={validationErrors.installationCapacity}
              >
                <DefaultVal>
                  <input
                    type="text"
                    className="kw-inp w172 radius4"
                    onChange={(e) => {
                      this.removeError(e.target.name);
                      VS.onInput("number", e);
                    }}
                    name="installationCapacity"
                    onFocus={this.removeError}
                  />
                  <span className="fixed">kW</span>
                </DefaultVal>
              </InputErrorMsgWrapper>
              <span className="option">설치 장수</span>
              <InputErrorMsgWrapper
                isError={validationErrors.installationCnt}
                message={validationErrors.installationCnt}
              >
                <DefaultVal>
                  <input
                    type="text"
                    className="unit-inp w172 radius4"
                    onChange={(e) => {
                      this.removeError(e.target.name);
                      VS.onInput("number", e);
                    }}
                    name="installationCnt"
                    onFocus={this.removeError}
                  />
                  <span className="fixed">{t('key415')}</span>
                </DefaultVal>
              </InputErrorMsgWrapper>
            </FormRow>
          </FormSplit>
          <FormSplit>
            {
              selectedPlantTypeId === 1 && (
                <>

                  <FormRow>
                    <FormThead width={LabelWidthClass(i18n)} required={false}>{t('key416')}</FormThead>
                    <InputErrorMsgWrapper
                      isError={validationErrors.floorPlanFile}
                      message={validationErrors.floorPlanFile}
                    >
                      <FileUpload
                        className="w436 radius4"
                        handleUploadFile={(category, fileInfos) => {
                          this.removeError(category);
                          this.doSetFile(category, fileInfos);
                        }}
                        category="floorPlanFile"
                        accept="image/*"
                      />
                    </InputErrorMsgWrapper>
                  </FormRow>
                  <FormRow>
                    <FormThead width={LabelWidthClass(i18n)} required={false}>{t('key419')}</FormThead>
                    <InputErrorMsgWrapper
                      isError={validationErrors.oneLineDiagramFile}
                      message={validationErrors.oneLineDiagramFile}
                    >
                      <FileUpload
                        className="w436 radius4"
                        handleUploadFile={(category, fileInfos) => {
                          this.removeError(category);
                          this.doSetFile(category, fileInfos);
                        }}
                        category="oneLineDiagramFile"
                        accept="image/*"
                      />
                    </InputErrorMsgWrapper>
                  </FormRow>
                  <FormRow>
                    <FormThead width={LabelWidthClass(i18n)}>
                      {t('key420')}
                      <br />
                      {t('key420A')}
                    </FormThead>
                    <InputErrorMsgWrapper
                      isError={validationErrors.serialNoFile}
                      message={validationErrors.serialNoFile}
                    >
                      <FileUpload
                        className="w436 radius4"
                        handleUploadFile={(category, fileInfos) => {
                          this.removeError(category);
                          this.doSetFile(category, fileInfos);
                        }}
                        category="serialNoFile"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onFocus={this.removeError}
                      />
                    </InputErrorMsgWrapper>
                    <a
                      className="download"
                      href="/files/시리얼번호양식파일.xlsx"
                      download
                    >
                      {t('key421')}
                    </a>
                  </FormRow>
                </>
              )
            }
            <FormRow>
              <FormThead width={LabelWidthClass(i18n)} required={true}>{t('key422')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.operationStartDt}
                message={validationErrors.operationStartDt}
              >
                <Date
                  name="operationStartDt"
                  handleDateChange={(name, dt) => {
                    this.removeError(name);
                    this.handleDateChange(name, dt);
                  }}
                  onFocus={this.removeError}
                />
              </InputErrorMsgWrapper>
              <FormThead width={LabelWidthClass(i18n)} className="ml-25" required={true}>{t('key424')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.serviceWarrantyDt}
                message={validationErrors.serviceWarrantyDt}
              >
                <DateCustom
                  name="serviceWarrantyDt"
                  handleDateChange={(name, dt) => {
                    this.removeError(name);
                    this.handleDateChange(name, dt);
                  }}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidthClass(i18n)} required={true}>
                {t('key425')}
                <br />
                {t('key425A')}
              </FormThead>
              <span className="option pl-0">{t('key426')}</span>
              <InputErrorMsgWrapper
                isError={validationErrors.unitPrice}
                message={validationErrors.unitPrice}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  onChange={(e) => {
                    this.removeError(e.target.name);
                    VS.onInput("number", e);
                  }}
                  name="unitPrice"
                />
              </InputErrorMsgWrapper>
              <span className="option pl-12">{t('key427')}</span>
            </FormRow>
            {
              selectedPlantTypeId === 2 && (
                <FormRow>
                  <FormThead width={LabelWidthClass(i18n)} required={true}>
                    연계 URL
                  </FormThead>
                  <InputErrorMsgWrapper
                    isError={validationErrors.externalUrl}
                    message={validationErrors.externalUrl}
                  >
                    <input
                      type="text"
                      className="w436 radius4"
                      onChange={(e) => {
                        this.removeError(e.target.name);
                      }}
                      name="externalUrl"
                    />
                  </InputErrorMsgWrapper>
                </FormRow>
              )
            }
            {
              selectedPlantTypeId === 1 && (
                <FormRow>
                  <FormThead width={LabelWidthClass(i18n)}>
                    {t('key428')}
                  </FormThead>
                  <Checkbox>
                    <input
                      type="checkbox"
                      name="optimizerYn"
                      id="optimizerYn"
                    />
                    <label htmlFor="optimizerYn"></label>
                    <span>{t('key429')}</span>
                  </Checkbox>
                </FormRow>
              )
            }
          </FormSplit>
          {
            selectedPlantTypeId === 1 && (
              <OptionInfoCreate columns={OptionInfoCreateGrid(i18n)}>
                <p>{t('key430')}</p>
                <ButtonArea>
                  <button
                    type="button"
                    className="radius5 mr-20"
                    onClick={() => this.moveNextStep(this.state.plantId)}
                  >
                    {t('key431')}
                  </button>
                  <button
                    type="button"
                    className="radius5"
                    onClick={() => this.moveNextStep(this.state.plantId)}
                  >
                    {t('key432')}
                  </button>
                </ButtonArea>
              </OptionInfoCreate>
            )
          }
          <BtnGroup>
            <button type="button" onClick={this.handlePlantList}>
              {t('key435')}
            </button>
            <button type="submit">{t('key436')}</button>
          </BtnGroup>
        </CreateForm>
      </>
    );
  }
}

export default withTranslation()(SolarPanelCreate);
